import { createTheme } from "@mui/material";

export const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        db: 1360,
        xl: 1536,
      },
    },
  });
  